import { FunctionComponent } from "react";
import { useBooks } from "../../features/HomePage/api/client";
import { usePageParam } from "../../hooks/usePageParam";
import BooksPageLayout from "../../features/BooksPage/components/BooksPageLayout/BooksPageLayout";

interface BooksPageProps {
  type: "bestsellerBooks" | "newcomingBooks";
  title: string;
}

const BooksPage: FunctionComponent<BooksPageProps> = ({ type, title }) => {
  const currentPage = usePageParam();

  const { data: bookList, isLoading, error } = useBooks(type, currentPage, 15);

  const seoTitle =
    type === "bestsellerBooks" ? "Бетселери в Читанці" : "Новинки в Читанці";

  return (
    <BooksPageLayout
      title={title}
      seoTitle={seoTitle}
      seoDescription={seoTitle}
      bookList={bookList}
      isLoading={isLoading}
      error={error}
      currentPage={currentPage}
    />
  );
};

export default BooksPage;
